export const ProfileStatuses = Object.freeze({
  COMPLETED: "completed",
  NOT_COMPLETED: "not-completed",
  COMPLETED_WITHOUT_PHONE_NUMBER: "completed-without-phonenumber",
  VERIFICATION_PENDING: "verification-pending",
  VERIFICATION_PENDING_WITHOUT_PHONE_NUMBER: "verification-pending-without-phonenumber"
})

export const Screens = Object.freeze({
  SUCCESS: "success",
  FORM: "form",
  ACTIVATION_FAILURE: "activation_failure",
  FALLBACK_ERROR: "fallback_error"
})

export const ERROR_STATUSES = Object.freeze({
  INVALID_INPUT: "INVALID_INPUT",
  INVALID_TOKEN: "INVALID_TOKEN",
  VALIDATION_FAILED: "VALIDATION_FAILED"
})